import { useState, useEffect } from 'react';
import Glossuk from './Glossuk'; 
import Glosspt from './Glosspt'; 

const Navbar = ({ling, comp, setLing, setComp, setOpac, menuVisiv, setMenuVisiv}) => {
    
    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
      ]);

      var oldComp = comp;
      
      useEffect(() => {
        const handleWindowResize = () => {
          setWindowSize([window.innerWidth, window.innerHeight]);
        };
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      });
    
    // Close the dropdown if the user clicks outside of it
    window.onclick = function(event) {
        // If target is not a dropdown element or the change language button...
        if (!event.target.matches('.dropbtn') & !event.target.matches('#uk') & !event.target.matches('#por')) {
            // If a map is shown, shift it back to the left and restore opacity (possibly redundant)
            if (document.getElementById("map")) {
                setOpac('1');
                document.getElementById("map").style.opacity = '1';
                document.getElementById("map").style.marginLeft = '0px';
                if (document.getElementById("menu")) {
                    document.getElementById("menu").style.marginLeft = '13px';
                }    
            }
            // hide the dropdown elements
            setMenuVisiv(false);
            setComp(oldComp);
        }
    }

    useEffect(() => { 
        if (document.getElementById("map")) { // toggle map left margin and opacity according to wether menu is visible
            if (menuVisiv) {
                setOpac('0.5');
                document.getElementById("map").style.opacity = () => '0.5';
                document.getElementById("map").style.marginLeft = '120px';
                if (document.getElementById("menu")) {
                    document.getElementById("menu").style.marginLeft = '160px';
                }
            } else {
                setOpac('1');
                document.getElementById("map").style.opacity = () => '1';
                document.getElementById("map").style.marginLeft = '0px';
                if (document.getElementById("menu")) {
                    document.getElementById("menu").style.marginLeft = '13px';
                }
            }
        };
        console.log('Visiv', menuVisiv);
    }, [menuVisiv, ling]) // rerender when menu visibility or language are changed 
    
    useEffect(() => {
        console.log('Ling', ling);
    }, [ling])

    if (document.getElementById("menu") && menuVisiv) {
        document.getElementById("menu").style.marginLeft = '160px';
    }

    let l = window.localStorage.ling;

    return ( 
      <div className="navbar">
        <div>
            <table id="Cab"><tbody>
                <tr>
                    <td width="4%">
                        <div className="dropdown">
                            <img id="myImage" onClick={ () => setMenuVisiv(!menuVisiv) }
                            className="dropbtn" 
                            src="/menu-icon.gif" width="40" height="50"></img>
                            
                        </div>
                    </td>
                    <td width="3%"></td>
                    <td width="3%">
                        <div id="bqmaps">
                        { (windowSize[0] > 550) && <b> bqmaps: </b> }
                        { !(windowSize[0] > 550) && <b> bqmaps </b> }
                        </div>
                    </td>
                    <td width="85%">
                        <div id="descr">
                        { (ling === 'pt') && (windowSize[0] > 550) && <b> Visualização em mapa da procura e oferta no metro do Porto </b>}
                        { (ling === 'uk') && (windowSize[0] > 550) && <b> Visualizing in a map Oporto metro's demand and supply </b>}
                        </div>
                    </td>
                    <td width="4%">
                        <div id="band">
                            <button id="ling" className="dropbtn"> 
                                {   (ling === 'pt') && 
                                    <img id="uk" src="/UK.png" width="40" height="40" 
                                    onClick={() => 
                                        {   setLing('uk'); 
                                            if (comp === 'glosspt') setComp('glossuk');
                                        }
                                    }>
                                    </img>}
                                {   (ling === 'uk') && 
                                    <img id="por" src="/Portugal.png" width="40" height="40" 
                                    onClick={() => 
                                        {   setLing('pt');
                                        if (comp === 'glossuk') setComp('glosspt')
                                        }
                                    }>
                                    </img>}
                            </button>
                        </div>
                    </td>            
                </tr>
            </tbody></table>
        </div>
        { ling === 'pt' && menuVisiv && <div id="myDropdown" className="dropdown-content">
            <a className="capitulo">MP</a>
            <a className="item" href="http://www.metrodoporto.pt/pages/462">Informação de Gestão Operacional </a>
            <a className="item" href="http://www.metrodoporto.pt/uploads/writer_file/document/58/20130116114152669228.pdf">Documentação da IG Operacional</a>
            <a className="capitulo">Apps</a>
            <a className="item" href="http://rede-160318.appspot.com/">Procura e oferta por troço, ano, mês, hora</a>
            <a className="item" href="http://util-171115.appspot.com/">Ibidem, dias úteis apenas</a>
            <a className="capitulo">Slideshows</a>
            <a className="item" href="https://drive.google.com/drive/folders/1Nywu8C8MsGFMr7jlxo7xvenYXTW7qXu4?usp=sharing">Matrizes OD agrupadas </a>
            <a className="capitulo">Referência</a>
            <a className="item" href="https://onedrive.live.com/view.aspx?resid=4739DC94C72D0FDD!2634&ithint=file%2cxlsx&authkey=!AJuBGEO1mUTzynY">Números e códigos de estações e zonas Andante </a>
            <a className="item" onClick= {() => {
                setComp('glosspt'); <Glosspt ling={ling} comp={comp} setComp={setComp} setLing={setLing}/>
            }}>Glossário </a>
            <a className="item" id="inic" href="/">Início </a>
        </div> }
        { ling === 'uk' && menuVisiv && <div id="myDropdownEn" className="dropdown-content">
            <a className="capitulo">MP</a>
            <a className="item" href="http://www.metrodoporto.pt/pages/462">Operational Management Information </a>
            <a className="item" href="http://www.metrodoporto.pt/uploads/writer_file/document/58/20130116114152669228.pdf">Operational MI Documentation</a>
            <a className="capitulo">Apps</a>
            <a className="item" href="http://rede-160318.appspot.com/">Demand and supply by stretch, year, month, hour</a>
            <a className="item" href="http://util-171115.appspot.com/">Ibidem, week days only</a>
            <a className="capitulo">Slideshows</a>
            <a className="item" href="https://drive.google.com/drive/folders/1Nywu8C8MsGFMr7jlxo7xvenYXTW7qXu4?usp=sharing">OD grouped matrices </a>
            <a className="capitulo">Reference</a>
            <a className="item" href="https://onedrive.live.com/view.aspx?resid=4739DC94C72D0FDD!2634&ithint=file%2cxlsx&authkey=!AJuBGEO1mUTzynY">Station and tariff zone numbers and codes </a>
            <a className="item" onClick= {() =>  {
                setComp('glossuk'); <Glossuk ling={ling} comp={comp} setComp={setComp} setLing={setLing}/>
            }}>Glossary </a>
            <a className="item" id="inic" href="/">Start </a>
        </div> }       
      </div>
    );
}

export default Navbar;